/**
 * /dashboard/leave/balances — Leave → Balance view (SOP §1.2;
 * Phase 3b — 2026-06-01).
 *
 * Own balance per type for the selected year (year picker + per-type
 * cards). Backend authorizes ?user_id= regardless; this is the "my
 * balance" view.
 *
 * Migration note: port of
 * frontend/src/app/(dashboard)/dashboard/leave/balances/page.tsx.
 * "use client" dropped; the entire body is the existing
 * LeaveBalanceTab component (ported in the same batch).
 */

import { createFileRoute } from "@tanstack/react-router";
import { TimeAndLeaveShell } from "@/components/shared/time-and-leave-shell";
import { LeaveFeatureGate } from "@/components/leave/leave-feature-gate";
import { LeaveBalanceTab } from "@/components/leave/leave-balance-tab";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/leave/balances",
)({
  component: LeaveBalancesRoute,
});

function LeaveBalancesRoute() {
  return (
    <TimeAndLeaveShell
      title="Leave balances"
      description="Your entitlement and usage by leave type."
    >
      <LeaveFeatureGate>
        <LeaveBalanceTab />
      </LeaveFeatureGate>
    </TimeAndLeaveShell>
  );
}
